import { render, staticRenderFns } from "./ProductAttribute.vue?vue&type=template&id=61f462d8&"
import script from "./ProductAttribute.vue?vue&type=script&lang=js&"
export * from "./ProductAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f462d8')) {
      api.createRecord('61f462d8', component.options)
    } else {
      api.reload('61f462d8', component.options)
    }
    module.hot.accept("./ProductAttribute.vue?vue&type=template&id=61f462d8&", function () {
      api.rerender('61f462d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ProductAttribute.vue"
export default component.exports